import { defineNuxtPlugin } from '#app/nuxt'
import { LazySvgoArrowRightTriangle } from '#components'
const lazyGlobalComponents = [
  ["SvgoArrowRightTriangle", LazySvgoArrowRightTriangle],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
